export default "__VITE_ASSET__BSRRBRAf__"